import { fireToast } from 'helpers/Toasts';

/** @deprecated for copyToClipboardV2 */
export const copyToClipboard = (
  event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  sourceText: string,
  askToClose: () => void,
) => {
  event.preventDefault;

  if (navigator) {
    navigator.clipboard.writeText(sourceText);
    fireToast({
      type: 'SUCCESS',
      text: 'Link copied to clipboard',
    });
    askToClose();
  } else {
    fireToast({
      type: 'ERROR',
      text: `Oops! Your browser doesn't support link copying`,
    });
  }
};

type TCopyToClipboard = {
  /** The text to be copied to clipboard */
  text: string;
  /** Called if text successfully copied */
  onSuccess: () => void;
  /** Called if failed to copy text */
  onFailure: () => void;
};

export const copyToClipboardV2 = ({
  text,
  onSuccess,
  onFailure,
}: TCopyToClipboard) => {
  if (navigator) {
    navigator.clipboard.writeText(text);
    onSuccess();
  } else {
    onFailure();
  }
};
